import Memberships from './memberships'
import Edit from './edit'
export default { Memberships, Edit }
